import {
  ChatWithYourDataLineEntry,
  IChatWithYourDataEntry,
} from "../../../groopit-js/client";

interface IStreamingChatWithYourDataLineEntry extends IChatWithYourDataEntry {
  isStreaming: boolean;
}

export class StreamingChatWithYourDataLineEntry
  extends ChatWithYourDataLineEntry
  implements IStreamingChatWithYourDataLineEntry
{
  isStreaming!: boolean;

  constructor(data?: IStreamingChatWithYourDataLineEntry) {
    super(data);
  }

  conversationId!: string;
  groopId!: string;
  userId!: string;
}
